export default __webpack_public_path__ + "assets/images/b03313ed716667548c442b55ed14227f.svg";